import { NetworkRequestState } from '../baseTypes';
import { PromotionalBannersWidgetData } from './types';

const defaultPromotionalBannersWidgetData: NonNullable<
  PromotionalBannersWidgetData['initialData']
> = {
  deviationPageBanner: false,
  profileCoverBanner: false,
};

export const defaultPromotionalBannersWidgetState: PromotionalBannersWidgetData =
  {
    initialData: defaultPromotionalBannersWidgetData,
    currentData: defaultPromotionalBannersWidgetData,
    isDirty: false,
    saveRequest: {
      status: NetworkRequestState.IDLE,
    },
  };
